<script setup lang="ts">
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import ToggleSwitch from '@/components/Interface/ToggleSwitch/ToggleSwitch.vue'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore'
import { computed } from 'vue'

const playerFlagsStore = usePlayerFlagsStore()

const isRingworldConstructionDefaultEnabled = computed(() => {
  return playerFlagsStore.getFlag('tutorial_ringworld_construction_default') === 'true'
})

// Toggle handler for ringworld construction default
const handleRingworldConstructionDefaultToggle = async () => {
  const newValue = isRingworldConstructionDefaultEnabled.value ? 'false' : 'true'
  await playerFlagsStore.setFlag('tutorial_ringworld_construction_default', newValue)
}
</script>

<template>
  <StandardCard title="Ringworld Construction">
    <div class="flex justify-between items-center">
      <div>
        <p>Set planet to automatically convert to ringworlds when captured/settled</p>
        <small>(When ringworld tech is available)</small>
      </div>
      <div class="flex items-center pb-1">
        <ToggleSwitch
          :modelValue="isRingworldConstructionDefaultEnabled"
          @update:modelValue="handleRingworldConstructionDefaultToggle"
        />
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>